import { ClaimStepContainerProps } from './ClaimStepContainer';
import Loader from '../../../common/Loader';
import React from 'react';

type Props = ClaimStepContainerProps & {
  text?: string;
  as: React.ComponentType<ClaimStepContainerProps>;
};

function LoadingStep(props: Props) {
  const { as: Container, text, ...restProps } = props;

  return (
    <Container {...restProps} onNext={null} onBack={null} onSaveDraft={null}>
      <Loader loadingText={text} />
    </Container>
  );
}

export default LoadingStep;
